// import { FaFacebook } from "react-icons/fa";
import { FaLinkedin, FaInstagram, FaYoutube, FaFacebook } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";



export default function KryzenSocialCard() {

    const socials = [
        {
          name: "LinkedIn",
          url: "https://in.linkedin.com/company/kryzen",
          icon: <FaLinkedin size={24} />,
          description: "Follow our agri-tech updates and innovations.",
          color: "blue",
        },
        {
          name: "Instagram",
          url: "https://www.instagram.com/kryzen_biotech",
          icon: <FaInstagram size={24} />,
          description: "See visuals from our farms, trainings & projects.",
          color: "pink",
        },
        {
          name: "YouTube",
          url: "https://www.youtube.com/@kryzenbiotech",
          icon: <FaYoutube size={24} />,
          description: "Watch hydroponic farm walkthroughs & tutorials.",
          color: "red",
        },
        {
          name: "Facebook",
          url: "https://facebook.com/kryzenbiotech",
          icon: <FaFacebook size={24} />,
          description: "Join our growing hydroponics community.",
          color: "azure",
        },
      ];
      
    return (
      <div className="card card-sm shadow-sm mt-4">
        <div className="card-body">
          <h3 className="card-title">Kryzen Biotech – Social Media</h3>
          <p className="text-muted mb-3">
            Stay connected with us across all major platforms.
          </p>
  
          <div className="list-group list-group-flush">
            {socials.map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="list-group-item list-group-item-action d-flex align-items-center"
              >

               
                <span
  className={`avatar bg-${s.color}-lt me-3 d-flex justify-content-center align-items-center`}
  style={{ width: "44px", height: "44px" }}
>
  {s.icon}
</span>
                <div className="flex-fill">
                  <div className="fw-bold">{s.name}</div>
                  <div className="text-muted small">{s.description}</div>
                </div>
                <FiChevronRight className="text-muted ms-auto" size={20} />

                <i className="ti ti-chevron-right text-muted ms-auto"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }
  